import Agent from '../agent'
import { toUrlParams } from '../base/url'
import { jump2TemplateMethod } from './base'
import { WX_PATH_PREFIX } from './mp-const'
import { mpSwitchTab } from './mp-base'

export function getIPath(params: {}) {
  const queryString = toUrlParams(params)
  return `${queryString ? `?${queryString}/` : '/'}`
}

/**
 * [$jump2home 跳转到首页]
 * @param  {[String]} params      [参数]
 */
export default function jump2home(params = {}) {
  const queryString = toUrlParams(params)
  if (Agent.anyminiprogram) {
    if (Agent.phoenix_wxapp || Agent.swan) {
      mpSwitchTab({
        phoenix_wxapp: `${WX_PATH_PREFIX.phx}/index/index?${queryString}`,
      })
      return
    }
  }
  const iPath = `${queryString ? `?${queryString}` : ''}`
  jump2TemplateMethod({
    iPath,
    mpPathMap: {
      // cityId, dateBegin, dateEnd
      dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}/products/products?${queryString}`,
      group_wxapp: `${WX_PATH_PREFIX.meituan}/products/simple?${queryString}`,
      hotel_wxapp: `${WX_PATH_PREFIX.hotelSub}/products/products?${queryString}`,
      phoenix_wxapp: `${WX_PATH_PREFIX.phx}/products/products?${queryString}`,
    },
    rnPathConfig: {
      versions: { phx: '3.5.0', meituan: '9.13.400', dianping: '10.18.0' },
      mrn_entry: 'homepage',
      mrn_component: 'kingkong-homepage',
      mrn_translucent: true,
      mrn_skeleton: 'phx_homepage.sk',
      mrn_backup_url: encodeURIComponent('https://minsu.dianping.com/'),
      params,
    },
    iaphx: `iaphx://iaphx.sankuai.com/guest/main?tabIndex=0${queryString ? `&${queryString}` : ''}`,
  })
}
